import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eb/i18n';
import { setWindowLocation } from '@eb/http';
import has from 'lodash/has';
import { formatUrl } from 'url-lib';

import { withMainControls } from '@eb/eds-structure';
import { TYPE_ERROR } from '@eb/eds-notification';
import { AlertChunky } from '@eb/eds-iconography';

import PageHeader from '../../components/PageHeader';
import ResetPasswordForm from '../../components/newForms/ResetPasswordForm';
import SplitContainer from '../../connectedComponents/SplitContainer';

import ToSModal from '../../connectedComponents/ToSModal';

import {
    SET_PASSWORD_FORM,
    PASSWORD_SET_TOKEN,
    INVALID_RESET_TOKEN,
    SET_PASSWORD_PATH,
} from '../../constants';
import { TOS_SET_PASSWORD_MUST_BE_ACCEPTED } from '../../constants/messages';
import {
    TOSMODAL_SET_PASSWORD_SHOWED,
    TOSMODAL_SET_PASSWORD_DENIED,
    TOSMODAL_SET_PASSWORD_ACCEPTED,
} from '../../constants/analytics';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/SET_PASSWORD_PATH
 */
class SetPasswordPage extends React.PureComponent {
    static propTypes = {
        handleSetPassword: PropTypes.func.isRequired,
        locale: PropTypes.string,
        hideMainNotification: PropTypes.func,
        addMainNotification: PropTypes.func,
        handleTrackSetPasswordClicked: PropTypes.func,
    };
    componentDidMount() {
        const { handleResetPasswordEmailClicked } = this.props;
        if (handleResetPasswordEmailClicked)
            handleResetPasswordEmailClicked({ isSet: true });
    }
    _handleShowNotification = (error) => {
        const { addMainNotification } = this.props;

        /*Limit the call to addMainNotification to only if
        a notification hasn't been shown since last submit.*/
        if (!this._hasNotification) {
            addMainNotification({
                type: TYPE_ERROR,
                children: error,
                iconType: <AlertChunky />,
            });

            this._hasNotification = true;
        }
    };
    _handleSubmit = (formData) => {
        const { clearAuthNotification, handleSetPassword } = this.props;
        // clear notification everytime form is submitted
        if (clearAuthNotification) {
            clearAuthNotification();
        }

        return handleSetPassword(formData);
    };
    _handleToSAccepted = () => {
        const { handleSetPassword, acceptToS } = this.props;

        acceptToS({
            onAccept: handleSetPassword,
            formName: SET_PASSWORD_FORM,
            actionName: TOSMODAL_SET_PASSWORD_ACCEPTED,
        });
    };
    _handleToSDisplay = () => {
        const { showToS } = this.props;

        showToS({
            actionName: TOSMODAL_SET_PASSWORD_SHOWED,
        });
    };
    _handleToSDenied = () => {
        const { cancelToS } = this.props;

        cancelToS({
            actionName: TOSMODAL_SET_PASSWORD_DENIED,
            notificationMessage: TOS_SET_PASSWORD_MUST_BE_ACCEPTED,
        });
    };

    _handleClearNotification = () => {
        const { hideMainNotification } = this.props;

        this._hasNotification = false;

        hideMainNotification && hideMainNotification();
    };

    render() {
        const {
            locale,
            router: {
                location: { query },
            },
            clearAuthNotification,
            form,
            recaptcha2PublicKey,
            showCaptcha,
            fp,
            handleTrackSetPasswordClicked,
        } = this.props;

        const pageHeaderProps = {
            headerText: gettext('Set your password'),
            subtitleText: gettext('Enter your new password below'),
            usesNewStyles: true,
        };
        const buttonCTA = gettext('Set password');
        let syncErrors;

        if (form[SET_PASSWORD_FORM]) {
            syncErrors = form[SET_PASSWORD_FORM].syncErrors;
        }

        // If the query not includes parameters to reset the password, we redirect to home page with error
        if (!has(query, PASSWORD_SET_TOKEN)) {
            setWindowLocation(
                formatUrl(SET_PASSWORD_PATH, {
                    [INVALID_RESET_TOKEN]: 1,
                }),
            );
        }
        const mustAcceptTOS = query['must_accept_tos'];
        let modalToS = (
            <ToSModal
                dataTestId="set-password-tos"
                onAcceptToS={this._handleToSAccepted}
                onCancelToS={this._handleToSDenied}
            />
        );
        const setPasswordSubmit = (formData) => {
            handleTrackSetPasswordClicked();
            if (mustAcceptTOS != 'True') {
                this._handleSubmit(formData);
            } else {
                this._handleToSDisplay();
            }
        };

        if (mustAcceptTOS != 'True') {
            modalToS = null;
        }

        return (
            <SplitContainer
                shouldShowSecondaryPanel={true}
                usesNewStyles={true}
                header={<PageHeader {...pageHeaderProps} />}
            >
                <>
                    <ResetPasswordForm
                        formErrors={syncErrors}
                        buttonCTA={buttonCTA}
                        onSubmit={setPasswordSubmit}
                        clearAuthNotification={clearAuthNotification}
                        locale={locale}
                        recaptcha2PublicKey={recaptcha2PublicKey}
                        showCaptcha={showCaptcha}
                        fp={fp}
                        showNotification={this._handleShowNotification}
                        clearNotification={this._handleClearNotification}
                    />
                    {modalToS}
                </>
            </SplitContainer>
        );
    }
}

export default withMainControls(SetPasswordPage);
